import { AxiosRequestConfig, ResponseType } from 'axios'
import coreApi from './core'

type HttpMethod = 'get' | 'post' | 'put' | 'patch' | 'delete'

interface ExecuteApiOptions {
  version?: 'v1' | 'v2'
  contentType?: string
  responseType?: ResponseType
  params?: any
}

const executeApiCall = async (
  method: HttpMethod,
  url: string,
  {
    version = 'v1',
    contentType = 'application/json',
    responseType = 'json',
    params,
    config = {},
  }: ExecuteApiOptions & { config?: AxiosRequestConfig } = {}
) => {
  try {
    const coreApiInstance = await coreApi(version)
    const baseConfig: AxiosRequestConfig = {
      headers: { 'Content-Type': contentType },
      responseType,
      ...config,
    }

    if (['get', 'delete'].includes(method)) {
      return coreApiInstance.serverApi[method](url, baseConfig).then(
        (res: any) => res?.data
      )
    } else {
      return coreApiInstance.serverApi[method](url, params, baseConfig).then(
        (res: any) => res?.data
      )
    }
  } catch (error) {
    throw error
  }
}

// 💬 Common API Calls

export const getData = (url: string) => executeApiCall('get', url)

export const getDataV2 = (url: string) =>
  executeApiCall('get', url, { version: 'v2' })

export const downloadData = (url: string) =>
  executeApiCall('get', url, { responseType: 'blob' })

export const downloadDatav2 = (url: string) =>
  executeApiCall('get', url, { version: 'v2', responseType: 'blob' })

export const postData = (url: string, params: any) =>
  executeApiCall('post', url, { params })

export const postFormData = (url: string, data: any) =>
  executeApiCall('post', url, {
    contentType: 'multipart/form-data',
    params: data,
  })

export const patchFormData = (url: string, data: any) =>
  executeApiCall('patch', url, {
    contentType: 'multipart/form-data',
    params: data,
  })

export const updateFromData = (url: string, data: any) =>
  executeApiCall('put', url, {
    contentType: 'multipart/form-data',
    params: data,
  })

export const updateData = (url: string, params: any) =>
  executeApiCall('put', url, { params })

export const patchData = (url: string, params: any) =>
  executeApiCall('patch', url, { params })

export const deleteData = (url: string) => executeApiCall('delete', url)

export const getConfigData = (url: string, config?: AxiosRequestConfig) =>
  executeApiCall('get', url, { config })
